async function getSectors() {
  const response = await fetch('/sectors.json');

  return await response.json();
}

export default getSectors;
